/* eslint-disable react/default-props-match-prop-types */
import { cx } from '@linaria/core';
import { textSmall } from 'styles/typography';
import React, { MouseEventHandler } from 'react';
import { starContainer, starCount, starBoxContainer, starBoxCount } from './Star_styles';

export interface StarProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> {
  count?: number;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  isStarred: boolean;
  variant?: 'default' | 'boxed';
}

const formatCount = (count: number): string => {
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k`;
  }
  return count.toString();
};

export const Star: React.FC<StarProps> = ({ className, isStarred, count, onClick, variant = 'default', ...rest }) => {
  const renderStar = () => {
    return onClick ? (
      <button
        data-testid={isStarred ? 'btn-unstar' : 'btn-star'}
        type="button"
        className={cx('starIcon', isStarred === true && 'starActive')}
        onClick={onClick}
        aria-label={isStarred ? 'Unstar' : 'Star'}
      />
    ) : (
      <div className={cx('starIcon', isStarred === true && 'starActive')} />
    );
  };

  if (variant === 'boxed') {
    return (
      <div className={cx(starContainer, starBoxContainer, className)} {...rest}>
        {count !== undefined && count > -1 && <span className={cx(textSmall, starBoxCount)}>{formatCount(count)}</span>}
        {renderStar()}
      </div>
    );
  }

  return (
    <div className={cx(starContainer, className)} {...rest}>
      {count !== undefined && count >= 0 && <span className={cx(textSmall, starCount)}>{count}</span>}
      {renderStar()}
    </div>
  );
};

Star.defaultProps = {
  isStarred: false,
  count: -1,
  variant: 'default',
};
